import React from 'react';
import { Link } from 'react-router-dom'; // React Router version

export default function SubscribeCol() {
	const links = [
		{ title: 'Earthworks', link: '/earthworks' },
		{ title: 'Concrete & Prep', link: 'concrete' },
		{ title: 'Utility Services', link: '/utilities' },
		{ title: 'Emergency Services', link: '/emergenci-service' },
	];

	return (
		<>
			<div className="footer-heading">
				<h6 className="text-white">Digging Into Our Skills</h6>
			</div>
			<ul className="list-unstyled footer-nav mb-0 d-flex flex-column">
				{links.map((item, index) => (
					<li className="position-relative" key={index}>
						<Link to={item.link}>{item.title}</Link>
					</li>
				))}
			</ul>
		</>
	);
}
